import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dataLoad } from '../../../../../redux/actions/autoCompleteActions'
import FindingField from './FindingField'
import { examFindingInfo, examFindings, examSelectedFinding } from '../../../../../redux/actions/exam/examFindingActions'
import { useActiveTestType } from '../../helpers/useActiveTestType'

let timeout = null
function FindingFieldWrap(props) {
  const { name, isHeaderModule } = props
  const dispatch = useDispatch()
  const staffId = useSelector(state => state.exam.exam.staff_id)
  const activeTestType = useActiveTestType(name)

  const handleFindingLoad = async (filter, isFieldFocused) => {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      let res = await findingsAutocompleteLoad(filter)
      handleShowDropdown('finding')
      if (isFieldFocused && res.length === 1) {
        dispatch(examSelectedFinding(res[0]))
      }
    }, 300);
  }

  const findingsAutocompleteLoad = async (filter) => {
    let res = await dispatch(dataLoad({
      klass: 'Settings::Finding',
      ...filter,
      filter: { test_type: activeTestType, staff_id: staffId },
    }))
    res = res.action.payload.data.data
    dispatch(examFindings(res ?? []))
    return res ?? []
  }

  const handleOnChange = (value) => {
    value && handleFindingLoad({ search: value })
  }

  const handleFieldFocus = (value) => {
    handleResetFindings()
    if(isHeaderModule){
      dispatch(examFindingInfo({ activeFieldKey: `header.${name}` }))
    }
    else{
      dispatch(examFindingInfo({ activeFieldKey: name }))
    }
    handleFindingLoad({ search: value }, true)
  }

  const handleAddFindingClicked = (val) => {
    // When new finding is created by clicking on add button
    findingsAutocompleteLoad({ search: val })
  }

  const handleResetFindings = () => {
    dispatch(examSelectedFinding({}))
    dispatch(examFindingInfo({ activeFieldType: '', activeFieldKey: '' }))
  }

  const handleShowDropdown = (showDropdown) => {
    dispatch(examFindingInfo({ activeFieldType: activeTestType, dropdownType: showDropdown }))
  }

  return (
    <>
      {/* Fields component (Input, Textarea) */}
      <FindingField
        {...props}
        onChange={(e) => handleOnChange(e.target.value)}
        onFocus={(e) => handleFieldFocus(e.target.value)}
        handleOnAddFindings={handleAddFindingClicked}
        handleFieldFocus={handleFieldFocus}
      />
    </>
  )
}

export default FindingFieldWrap;